import React, { useState, useEffect, useContext } from "react";
import {
  Check,
  CheckCheck,
  Pin,
  Plus,
  ArrowLeft
} from "lucide-react";
import { useNavigate } from 'react-router-dom';
import "../../assets/css/WhatsAppChatList.css";
import badgev from '../../assets/images/Twitter_Verified_Badge.png';
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
/**
 * Dummy chat data – extend with your real contacts.
 * verified ➜ shows a neon check‑badge.
 */
  
  function ChatItem({ chat }) {
    const {
      id,
      name,
      avatar,
      lastMessage,
      lastMessageTime,
      unread,
      pinned,
      read,
      delivered,
      verified,
    } = chat;
  
    const Tick = () => {
      if (read) return <CheckCheck size={16} className="tick" />;
      if (delivered) return <Check size={16} className="tick" />;
      return null;
    };
  
    return (
      <Link to={"/chat/"+id} className="chat-item">
        <img src={avatar} alt={name} className="avatar" />
  
        <div className="chat-main">
          <div className="chat-top">
            <h3 className="chat-name">
              {name}
              {verified && <img src={badgev} style={{width:'20px'}}/>}
            </h3>
            <div className="chat-time">
              {pinned && <Pin size={14} />}
              <span>{lastMessageTime}</span>
            </div>
          </div>
  
          <div className="chat-bottom">
            <Tick />
            <span className="chat-last">{lastMessage}</span>
          </div>
        </div>
  
        {unread > 0 && <div className="unread-badge">{unread}</div>}
      </Link>
    );
  }
  
  export default function ChatList({ onBack }) {
    const [showJoin, setShowJoin] = useState(false);
    const [groupId, setGroupId] = useState("");
    const [chats, setchats] = useState([]);
    const { Groupinfo,GroupAdd } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };
    const handleJoin = () => {
      if (!groupId.trim()) return;
      // TODO: integrate actual join‑group logic
      console.log("Join group with ID:", groupId);
      GroupAdd(groupId,(res) => {
        if (res.status === 0) {
          alert(res.msg);
          return;
        }
        let daa = res.data;
        Groupinfo((res) => {
          if (res.status === 0) {
            alert(res.msg);
            return;
          }
          let daa = res.data;
          setchats(daa);
        });
      })
      setGroupId("");
      setShowJoin(false);
    };
    useEffect(() => {
      Groupinfo((res) => {
        if (res.status === 0) {
          alert(res.msg);
          return;
        }
        let daa = res.data;
        setchats(daa);
      });
    }, [Groupinfo]);
  
    return (
      <div className="chat-list">
        <header className="headers">
          <button
            className="back-btn"
            title="Back"
            onClick={handleGoBack}
          >
            <ArrowLeft size={20} />
          </button>
  
          <h2>Chats</h2>
  
          <button
            className="new-chat-btn"
            title="Join group"
            onClick={() => setShowJoin(true)}
          >
            <Plus size={24} />
          </button>
        </header>
  
        {chats.map((chat) => (
          <ChatItem key={chat.id} chat={chat} />
        ))}
  
        {/* ===== Join Group Modal ===== */}
        {showJoin && (
          <div className="modal-overlay" onClick={() => setShowJoin(false)}>
            <div className="modals" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-btn"
                onClick={() => setShowJoin(false)}
                aria-label="Close"
              >
                X
              </button>
  
              <h3>Join Group</h3>
              <input
                type="text"
                value={groupId}
                onChange={(e) => setGroupId(e.target.value)}
                placeholder="Enter Group ID"
              />
              <button className="primary-btn" onClick={handleJoin}>
                Join Now
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }